export const MuiDatePicker = {
  MuiDateCalendar: {
    styleOverrides: {
      root: {},
    },
  },
};
